import { IConfigurations } from '../../../configurations/types';
import { IApiConfiguration } from './configuration.types';

const extractCaptchaData = (
  apiConfiguration: IApiConfiguration,
  siteKeyKey: string,
  domainKey: string
) => {
  const siteKey = apiConfiguration.attributes.captcha[siteKeyKey];
  const domain = apiConfiguration.attributes.captcha[domainKey];

  return siteKey && domain
    ? {
        siteKey,
        domain,
      }
    : undefined;
};

export const configurationSerializer = (
  apiConfiguration: IApiConfiguration
): IConfigurations => {
  const login = extractCaptchaData(
    apiConfiguration,
    'login_publickey',
    'login_domain'
  );
  const registration = extractCaptchaData(
    apiConfiguration,
    'post_account_publickey',
    'post_account_domain'
  );

  return {
    captcha: {
      login,
      registration,
    },
    featureFlipping: {
      eligibleForLegalCheck:
        apiConfiguration.attributes.feature_flipping.eligible_for_legal_check,
      brand: apiConfiguration.attributes.feature_flipping.brand,
      regular: apiConfiguration.attributes.feature_flipping.regular,
      market: apiConfiguration.attributes.feature_flipping.market,
    },
  };
};
